/* eslint-disable camelcase */

import { createAction, handleActions } from 'redux-actions';
import { useRedux } from 'util/hook/redux';

import { State as GlobalState } from './reducers';

export interface MultiMediaReadItemProperty {
	id: string;
	topic: string;
	time?: string;
	mp3: string;
	introduce?: string;
}

interface MultiMediaReadGroupProperty {
	id: string;
	items: MultiMediaReadItemProperty[];
}

export const getMultiMediaReadList = createAction('GET_MULTIMEDIA_READ_LIST');

export interface State {
	readList: {
		data: MultiMediaReadGroupProperty[];
		year: string[];
	};
}

export const defaultState: State = {
	readList: {
		data: [
			{
				id: '102',
				items: [
					{
						id: '102-01',
						topic: '吳晟',
						time: '58分鐘',
						mp3: '吳晟.mp3',
					},
					{
						id: '102-02',
						topic: '林良',
						time: '50分鐘',
						mp3: '林良.mp3',
					},
					{
						id: '102-03',
						topic: '司馬中原',
						time: '47分鐘',
						mp3: '司馬中原.mp3',
					},
					{
						id: '102-04',
						topic: '瓦歷斯．諾幹',
						time: '50分鐘',
						mp3: '瓦歷斯．諾幹.mp3',
					},
					{
						id: '102-05',
						topic: '白先勇',
						time: '49分鐘',
						mp3: '白先勇.mp3',
						introduce:
							'廣西桂林人，台大外文系畢業，後赴美到愛荷華大學作家工作室研究創作，獲碩士學位後任教於加州大學。曾創辦《現代文學》雜誌。著有短篇小說集《寂寞的十七歲》、《台北人》，長篇小說《孽子》，散文集《驀然回首》、《第六集手指》，並有劇作《遊園驚夢》等多種。白先勇吸收西洋現代文學寫作技巧，融入到中國傳統表現方式之中，描寫新舊交替時代人物的故事與生活，富歷史興衰與人世滄桑感。',
					},
					{
						id: '102-06',
						topic: '劉克襄',
						time: '55分鐘',
						mp3: '劉克襄.mp3',
					},
					{
						id: '102-07',
						topic: '方文山',
						time: '51分鐘',
						mp3: '方文山.mp3',
					},
					{
						id: '102-08',
						topic: '黃春明',
						time: '57分鐘',
						mp3: '黃春明.mp3',
					},
					{
						id: '102-09',
						topic: '藍博洲談呂赫若',
						time: '53分鐘',
						mp3: '藍博洲談呂赫若.mp3',
					},
					{
						id: '102-10',
						topic: '陳若曦',
						time: '58分鐘',
						mp3: '陳若曦_10210.mp3',
					},
					{
						id: '102-11',
						topic: '王文興',
						time: '56分鐘',
						mp3: '王文興.mp3',
						introduce:
							'王文興， 福建人，1939年生，在台灣長大。  台北師大附中畢業，入台大外文系，獲文學士學位，為《現代文學》雜誌創辨人之一。  曾任教於國立臺灣大學外文系，擔任小說課程；退休後開設中國古典文學講座，提倡精讀。  《家變》為王文興耗時七年(1966-1973)所撰之長篇小說，  描寫一個現代知識青年在成長期間所遭遇的精神衝突，檢討家庭和社會的問題，  更進一步發掘中國文字的多義性，以形式的創造肯定主題的嚴肅；  愛之者奉為文學瑰寶，厭之者誣為洪水猛獸；  出版以來廣受海內外學術界的注目，被譽為五四以來最偉大的小說之一。',
					},
					{
						id: '102-12',
						topic: '愛亞',
						time: '53分鐘',
						mp3: '愛亞.mp3',
					},
					{
						id: '102-13',
						topic: '鍾玲',
						time: '45分鐘',
						mp3: '鍾玲.mp3',
					},
					{
						id: '102-14',
						topic: '周芬伶談琦君',
						time: '46分鐘',
						mp3: '周芬伶談琦君.mp3',
					},
					{
						id: '102-15',
						topic: '周芬伶',
						time: '50分鐘',
						mp3: '周芬伶.mp3',
					},
					{
						id: '102-16',
						topic: '王鈺婷談艾雯',
						time: '55分鐘',
						mp3: '王鈺婷談艾雯.mp3',
					},
					{
						id: '102-17',
						topic: '阿盛',
						time: '56分鐘',
						mp3: '阿盛.mp3',
					},
					{
						id: '102-18',
						topic: '廖輝英',
						time: '56分鐘',
						mp3: '廖輝英.mp3',
					},
					{
						id: '102-19',
						topic: '李昂',
						time: '59分鐘',
						mp3: '李昂.mp3',
					},
					{
						id: '102-20',
						topic: '陳芳明',
						time: '53分鐘',
						mp3: '陳芳明.mp3',
					},
					{
						id: '102-21',
						topic: '向陽',
						time: '53分鐘',
						mp3: '向陽.mp3',
					},
					{
						id: '102-22',
						topic: '向陽談胡適',
						time: '52分鐘',
						mp3: '向陽談胡適.mp3',
					},
					{
						id: '102-23',
						topic: '焦桐',
						time: '56分鐘',
						mp3: '焦桐.mp3',
					},
					{
						id: '102-24',
						topic: '瘂弦',
						time: '58分鐘',
						mp3: '瘂弦.mp3',
						introduce:
							'本名王慶麟，河南南陽人，一九三二年生，青年時代於大動亂中入伍，隨軍輾轉來臺；復興崗學院影劇系畢業後，服務於海軍。瘂弦曾應邀參加愛荷華大學（University of Iowa, Iowa City）國際創作中心，嗣後入威斯康辛大學（University of Wisconsin, Madison），獲碩士學位。曾主編《創世紀》、《詩學》、《幼獅文藝》等雜誌，任聯合報副總編輯間副刊主編二十餘年，並曾主講新文學於各大學，現專事寫作。瘂弦以詩之開創和拓植知名，民謠寫實與心靈探索的風格體會，蔚為現代詩大家，從之者既眾，影響最為深遠。詩全集有《瘂弦詩集》行世，另有論述《中國新詩研究》、《聚繖花序》I、II、《記哈客詩想》等。',
					},
					{
						id: '102-25',
						topic: '封德屏談張秀亞',
						time: '53分鐘',
						mp3: '封德屏談張秀亞.mp3',
					},
					{
						id: '102-26',
						topic: '林文義',
						time: '54分鐘',
						mp3: '林文義.mp3',
					},
					{
						id: '102-27',
						topic: '詹澈',
						time: '51分鐘',
						mp3: '詹澈.mp3',
					},
					{
						id: '102-28',
						topic: '吳明益',
						time: '51分鐘',
						mp3: '吳明益.mp3',
					},

					{
						id: '102-29',
						topic: '雷驤',
						time: '52分鐘',
						mp3: '雷驤.mp3',
					},
					{
						id: '102-30',
						topic: '張曉風',
						time: '54分鐘',
						mp3: '張曉風.mp3',
					},
					{
						id: '102-31',
						topic: '廖玉蕙',
						time: '56分鐘',
						mp3: '廖玉蕙.mp3',
					},
					{
						id: '102-32',
						topic: '蔡珠兒',
						time: '57分鐘',
						mp3: '蔡珠兒.mp3',
					},
					{
						id: '102-33',
						topic: '應鳳凰談林海音',
						time: '59分鐘',
						mp3: '應鳳凰談林海音.mp3',
					},

					{
						id: '102-34',
						topic: '蕭蕭',
						time: '55分鐘',
						mp3: '蕭蕭.mp3',
					},
					{
						id: '102-35',
						topic: '張曼娟',
						time: '57分鐘',
						mp3: '張曼娟.mp3',
					},
					{
						id: '102-36',
						topic: '柯裕棻',
						time: '55分鐘',
						mp3: '柯裕棻.mp3',
					},
					{
						id: '102-37',
						topic: '陳義芝',
						time: '54分鐘',
						mp3: '陳義芝.mp3',
					},
					{
						id: '102-38',
						topic: '施叔青',
						time: '54分鐘',
						mp3: '施叔青.mp3',
						introduce:
							'台灣鹿港人，紐約市立大學戲劇碩士，十七歲時以處女作〈壁虎〉登上文壇，寫作之餘並從事平劇、歌仔戲研究，曾任教於政大及淡江。一九七七年赴香港任職香港藝術中心亞洲節目部策畫主任，曾任東華大學駐校作家。著有《愫細怨》、《維多利亞俱樂部》、香港三部曲：《她名叫蝴蝶》、《遍山洋紫荊》、《寂寞雲園》、《微醺彩妝》、《枯木開花》、《兩個芙列達．卡蘿》、台灣三部曲：《行過洛津》、《風前塵埃》、《三世人》等。  第十二屆國家文藝獎文學類得主。作品曾獲《中國時報．開卷》年度十大好書、《中國時報》文學推薦獎、《聯合報．讀書人》年度最佳書獎、台北市文化局文學獎、上海《文匯報》散文獎，其中「香港三部曲」入選一九九九年《亞洲週刊》二十世紀中文小說一百強。作品有英、日、法、韓、西班牙、捷克文等譯本。',
					},
					{
						id: '102-39',
						topic: '陳雪',
						time: '50分鐘',
						mp3: '陳雪.mp3',
					},
					{
						id: '102-40',
						topic: '尉天驄談王禎和',
						time: '49分',
						mp3: '尉天驄談王禎和.mp3',
					},
					{
						id: '102-41',
						topic: '鴻鴻',
						time: '57分鐘',
						mp3: '鴻鴻.mp3',
					},
					{
						id: '102-42',
						topic: '向明',
						time: '56分鐘',
						mp3: '向明.mp3',
						introduce:
							'本名董平，一九二八年生，湖南長沙人，空軍通信電子學校畢業，曾在空軍服役多年，以上校退伍。藍星詩社資深同仁，歷任藍星詩刊主編、中華日報副刊編輯、台灣詩學季刊社社長等。曾獲優秀青年詩人獎、文協文藝獎章、中山文藝獎、國家文藝獎等。作品被選入國內外各大詩選。除寫詩外，現為報紙專欄作家，評論及散文經常散見各報。詩評家謂其詩多取材自日常生活周邊的感覺與識見，詩寫生活情題、偶有批判與反諷，唯詩如其人一樣溫和大度、故有「詩壇儒者」譽稱。其詩明朗清澈，唯因慣用機智手法，進行異物或異事的聯接，也因此能在平實中生發詩趣與詩味，自成一風格。 出版有詩集《雨天書》、《狼煙》、《青春的臉》、《水的回想》、《地水火風》、《低調之歌》……等多種。',
					},
					{
						id: '102-43',
						topic: '蔡文章談葉石濤',
						time: '57分鐘',
						mp3: '蔡文章談葉石濤.mp3',
					},
					{
						id: '102-44',
						topic: '康原談賴和',
						time: '56分鐘',
						mp3: '康原談賴和.mp3',
					},
					{
						id: '102-45',
						topic: '駱以軍',
						time: '56分鐘',
						mp3: '駱以軍.mp3',
					},
					{
						id: '102-46',
						topic: '鍾怡彥談鍾理和',
						time: '56分鐘',
						mp3: '鍾怡彥談鍾理和.mp3',
					},
					{
						id: '102-47',
						topic: '蔡素芬',
						time: '60分鐘',
						mp3: '蔡素芬.mp3',
					},
					{
						id: '102-48',
						topic: '夏曼．藍波安',
						time: '58分鐘',
						mp3: '夏曼．藍波安.mp3',
					},
					{
						id: '102-49',
						topic: '朱天心',
						time: '58分鐘',
						mp3: '朱天心.mp3',
					},
					{
						id: '102-50',
						topic: '鄭清文',
						time: '58分鐘',
						mp3: '鄭清文.mp3',
					},
					{
						id: '102-51',
						topic: '鄭愁予',
						time: '60分鐘',
						mp3: '鄭愁予.mp3',
						introduce:
							'原名鄭文韜，一九三三年一個軍人家庭，幼年隨父轉戰馳徒於大江南北，山川文物既入秉異之懷乃成跌宕宛轉之詩篇。鄭愁予在新竹長大，畢業於中興大學，曾在基隆港口工作多年，臺灣的風物情感塑造他的藝術背景，襯托廣大中國的局面。詩人出版詩集有《夢土上》、《窗外的女奴》、《衣缽》、《燕人行》、《雪的可能》、《刺繡的歌謠》、《寂寞的人坐著看花》等多種，其作品之語言意象和風流蘊藉，早蔚為四十年代現代詩最深遠廣大的影響之一。賽外江南的寓意，因愁予詩而明朗；臺灣鄉土的意識，在愁予詩中落實為山岳、海灣、村莊。惟意識貫通，關懷普遍，於細密精緻處前後如一，詩的人文性格愈見超越，筆法則爐火純青，漸臻於無形。',
					},
					{
						id: '102-52',
						topic: '余光中',
						time: '54分鐘',
						mp3: '余光中.mp3',
						introduce:
							'福建永春人，一九二八年生於南京，臺灣大學外文系畢業，美國愛荷華大學（Iowa）碩士，曾任臺灣師範大學、政治大學、香港中文大學等校教授，數度講學美洲、現任國立中山大學講座教授。其五十年文學生涯悠遠、遼闊、深入，著作凡五十餘種，其中將近一半為詩集，風格多樣，主題繁複。文學活動廣大而恆久，詩藝爐火純青，為當代文學名家。余光中才學出眾，文采斐然，始終是文壇焦點，藉由深厚的中國古典文學涵養，與英美文學的專業訓練，開創出中國現代詩、文、評論及翻譯之新風貌，著作等身，至今仍筆耕不綴。著有詩集《舟子的悲歌》《藍色的羽毛》、《鐘乳石》、《萬聖節》、《敲打樂》、《在冷戰的年代》、《白玉苦瓜》、《天狼星》……等多種。',
					},
				],
			},
			{
				id: '103',
				items: [
					{
						id: '103-01',
						topic: '洛夫',
						time: '58分鐘',
						mp3: '洛夫.mp3',
						introduce:
							'本名莫洛夫，一九二八年生於湖南衡陽，淡江大學英文系畢業，曾任教東吳大學外文系。一九五四年與張默、瘂弦共同創辦《創世紀》詩刊，歷任總編輯數十年，作品被譯成英、法、日、韓、荷蘭、瑞典等文。洛夫早年為一超現實主義詩人，作品表現手法近乎魔幻，曾被詩壇譽為『詩魔』。近年則沉潛於書法之探索，不僅長於魏碑漢隸，尤精於行草，曾多次應邀在台北、菲律賓、馬來西亞、溫哥華、紐約等地展出。洛夫創作以詩為主，次及散文、評論和翻譯。主題多取材於生活感受，並寄情於天地萬物，尤其著重於對人生的深刻反思；主要風格在熔個人熱情、歷史意識、時代精神於一爐，透過特殊的冷雋的意象，表現出民族特有的人文精神以及對現實的深沉關注。洛夫著作甚豐，出版詩集有《靈河》、《石室之死亡》、《外外集》、《魔歌》、《時間之傷》、《漂木》……等多種。',
					},
					{
						id: '103-02',
						topic: '王盛弘',
						time: '58分鐘',
						mp3: '王盛弘.mp3',
					},
					{
						id: '103-03',
						topic: '孫梓評',
						time: '57分鐘',
						mp3: '孫梓評.mp3',
					},
					{
						id: '103-04',
						topic: '管管',
						time: '53分鐘',
						mp3: '管管.mp3',
						introduce:
							'本名管運龍，魯地介根國人氏，據說乃是雲南少數民族外星人遺民，不幸生長在地球這個混球之鄉，更不幸長成在一個貪婪的島上。還好沒留在魯國那個野蠻的地方。寫詩以消愁五十多年，寫散文以消恨四十多載，演戲以忘憂三十多春，畫畫以洩憤半個多甲子。與梁幼菁女史結髮，蒼髮紅顏，傳為佳話，不久天送麟兒得一子，名喚「管領風」，本想取名「管領風騷」惜未果。著有詩集《荒蕪之臉》、《管管詩選》、《管管‧世紀詩選》、《茶禪詩畫》等，散文《請坐月亮請坐》等四本，畫若干幅，電影二十多部，得過兩個詩首獎，做過愛荷華大學作家工作坊作家，與「中國的良心」劉賓雁同窗。',
					},
					{
						id: '103-05',
						topic: '林黛嫚',
						time: '60分鐘',
						mp3: '林黛嫚.mp3',
					},
					{
						id: '103-06',
						topic: '辛鬱',
						time: '58分鐘',
						mp3: '辛鬱.mp3',
						introduce:
							'本名宓世森，浙江慈谿人，一九三三年生於杭州，一九五○年六月起成長、定居在台灣。一九四八年中，辛鬱逃家從軍，中止了初中學業，自此一路自學，成為一個詩人。五四年後拜識前輩詩人紀弦、覃子豪等，加入紀弦發起組成的「現代派」，並亦為「藍星」寫詩。「創世紀」詩社成立，三位創辦人張默、洛夫、瘂弦均服役軍中，頗覺意氣相投，遂亦成為「創世紀」的一員。一九六九年自軍中退伍，隨即參與推廣科學普及工作，並擔任多家雜誌（《人與社會》、《國中生月刊》等）的主編、總編輯、顧問，數十年與文字結緣。期間除寫詩外，兼寫小說、雜文、電視劇本，並為多項文學藝術活動的發起人。出版有《軍曹手記》、《豹》、《因海之死》、《在那張冷臉背後》等多部詩集。',
					},
					{
						id: '103-07',
						topic: '楊索',
						time: '58分鐘',
						mp3: '楊索.mp3',
					},
					{
						id: '103-08',
						topic: '劉大任',
						time: '58分鐘',
						mp3: '劉大任.mp3',
						introduce:
							'抗戰期間出生於湘贛邊界的山區，九歲時隨父母到台灣。畢業於台灣大學哲學系。  台大哲學系畢業，一九六六年就讀美國柏克萊加州大學政治研究所，後因投入保釣運動，放棄博士學位。一九七二年考入聯合國秘書處，一九九九年退休。  早期參與台灣的現代主義文學運動，為「劇場」、「文學季刊」等刊物同人，探討文學與現實之間的關係問題。  創作包括小說集：《紅土印象》、《杜鵑啼血》、《浮游群落》（長篇）、《秋陽似酒》、《晚風習習》。評論集：《走出神話國》、《神話的破滅》。散文集：《薩伐旅》、《走過蛻變的中國》。運動文集：《強悍而美麗》。',
					},
					{
						id: '103-09',
						topic: '巴代',
						time: '58分鐘',
						mp3: '巴代.mp3',
					},
					{
						id: '103-10',
						topic: '鄭炯明',
						time: '58分鐘',
						mp3: '鄭炯明.mp3',
					},
					{
						id: '103-11',
						topic: '童偉格',
						time: '58分鐘',
						mp3: '童偉格.mp3',
					},
					{
						id: '103-12',
						topic: '張默',
						time: '58分鐘',
						mp3: '張默.mp3',
						introduce:
							'本名張德中，安徽無為人，一九三一年生，童年在故鄉讀私塾、簡師、南京成美中學。一九四九年春，由南京輾轉來台，旋即參加海軍。一九五四年秋與洛夫、瘂弦創辦《創世紀詩刊》迄今。著有詩集《紫的邊陲》、《上昇的風景》、《無調之歌》等多種；編有《新詩三百首》、《小詩‧床頭書》等二十多種。曾獲新聞局優良著作金鼎獎、國軍新文藝長詩金像獎、中山文藝獎新詩獎、中國文藝協會榮譽文藝獎章、第三屆五四獎文學編輯獎。詩作曾被譯成多種外國文字。對臺灣現代詩的耕耘有目共睹。近年再以八十高齡，歷時五月，以毛筆宣紙一點一撇的草成，計抄四代詩人一百八十六家六百三十餘首詩作，成一《台灣現代詩手抄本》。各卷單獨成章，每家篇首並加蓋特別製作的閑章，以期紅黑相間，井然有序，綻放「詩與毛筆字」相互交疊，呼吸潺潺不絕的抒情之美。',
					},
					{
						id: '103-13',
						topic: '李維菁',
						time: '58分鐘',
						mp3: '李維菁.mp3',
					},
					{
						id: '103-14',
						topic: '亮軒',
						time: '58分鐘',
						mp3: '亮軒.mp3',
					},
					{
						id: '103-15',
						topic: '路寒袖',
						time: '59分鐘',
						mp3: '路寒袖.mp3',
					},
					{
						id: '103-16',
						topic: '賴香吟',
						time: '58分鐘',
						mp3: '賴香吟.mp3',
					},
					{
						id: '103-17',
						topic: '隱地',
						time: '58分鐘',
						mp3: '隱地.mp3',
					},
					{
						id: '103-18',
						topic: '胡淑雯',
						time: '58分鐘',
						mp3: '胡淑雯.mp3',
					},
					{
						id: '103-19',
						topic: '藍博洲',
						time: '61分鐘',
						mp3: '藍博洲.mp3',
					},
					{
						id: '103-20',
						topic: '袁瓊瓊',
						time: '58分鐘',
						mp3: '袁瓊瓊.mp3',
					},
					{
						id: '103-21',
						topic: '楊富閔',
						time: '56分鐘',
						mp3: '楊富閔.mp3',
					},
					{
						id: '103-22',
						topic: '李欣倫',
						time: '57分鐘',
						mp3: '李欣倫.mp3',
					},
					{
						id: '103-23',
						topic: '季季',
						time: '57分鐘',
						mp3: '季季.mp3',
					},
					{
						id: '103-24',
						topic: '白靈',
						time: '58分鐘',
						mp3: '白靈.mp3',
					},
					{
						id: '103-25',
						topic: '陳淑瑤',
						time: '59分鐘',
						mp3: '陳淑瑤.mp3',
					},
					{
						id: '103-26',
						topic: '游乾桂',
						time: '59分鐘',
						mp3: '游乾桂.mp3',
					},
					{
						id: '103-27',
						topic: '楊澤',
						time: '55分鐘',
						mp3: '楊澤.mp3',
					},
					{
						id: '103-28',
						topic: '劉梓潔',
						time: '55分鐘',
						mp3: '劉梓潔.mp3',
					},
					{
						id: '103-29',
						topic: '許悔之',
						time: '57分鐘',
						mp3: '許悔之.mp3',
					},
					{
						id: '103-30',
						topic: '王文華',
						time: '56分鐘',
						mp3: '王文華.mp3',
					},
					{
						id: '103-31',
						topic: '楊青矗',
						time: '47分鐘',
						mp3: '楊青矗.mp3',
						introduce:
							'楊青矗，台灣鄉土文學作家，中華民國前國策顧問，本名楊和雄，曾任美麗島雜誌高雄分社主任，台灣筆會會長及敦理出版社發行人、社長。他的工人小說在臺灣鄉土文學論戰成為討論對象。1979年因美麗島事件入獄，1983年出獄。代表作為《在室男》、《工廠女兒圈》、《心癌》、《連雲夢》、《工廠人》、《楊青矗與國際作家對話》、《在室女》、《給台灣的情書》、《生命的旋律》、《筆聲的迴響》、《女企業家》等，此外還編有《台華雙語辭典》、《台語注音讀本》、《台語語彙辭典》、《台灣俗語辭典》、《台詩三百首》等書，他的文學具有國際知名度。',
					},
					{
						id: '103-32',
						topic: '陳育虹',
						time: '54分鐘',
						mp3: '陳育虹.mp3',
					},
					{
						id: '103-33',
						topic: '廖鴻基',
						time: '56分鐘',
						mp3: '廖鴻基.mp3',
					},
					{
						id: '103-34',
						topic: '羅智成',
						time: '58分鐘',
						mp3: '羅智成.mp3',
					},
					{
						id: '103-35',
						topic: '何致和',
						time: '57分鐘',
						mp3: '何致和.mp3',
					},
					{
						id: '103-36',
						topic: '林俊穎',
						time: '59分鐘',
						mp3: '林俊穎.mp3',
					},
					{
						id: '103-37',
						topic: '趙剛談陳映真',
						time: '53分鐘',
						mp3: '趙剛談陳映真.mp3',
						introduce:
							'陳映真，原名陳永善，1959年就讀淡江文理學院外文系二年級時發表〈麵攤〉晉身文壇。其後創作〈我的弟弟康雄〉、〈鄉村的教師〉等名篇，1961年畢業後為《文學季刊》司人。1968年應美國愛荷華大學邀請參加國際寫作計劃，行前被當局因政治原因逮捕，1975年獲釋。出獄後發表〈夜行貨車〉、〈上班族的一日〉等四個「華盛頓大樓」系列作品的中篇小說，及反映台灣白色恐怖時期政治悲情的〈鈴璫花〉、〈山路〉等名作。  曾主辦以現場攝影報導為主的文學刊物《人間》，在台灣地區和海內外產生深遠影響。1997年獲中國社科院授予名譽高級研究員稱號，2003年十二月獲馬來西亞第二屆「花蹤世界華文文學獎」。  主要作品見台灣洪範版「陳映真小說集」六冊，此外尚有評論集《知識人的偏見》、《孤兒的歷史、歷史的孤兒》等。',
					},
					{
						id: '103-38',
						topic: '簡媜',
						time: '52分鐘',
						mp3: '簡媜.mp3',
					},
					{
						id: '103-39',
						topic: '甘耀明',
						time: '58分鐘',
						mp3: '甘耀明.mp3',
					},
					{
						id: '103-40',
						topic: '林煥彰',
						time: '57分鐘',
						mp3: '林煥彰.mp3',
					},
					{
						id: '103-41',
						topic: '王聰威',
						time: '57分鐘',
						mp3: '王聰威.mp3',
					},
					{
						id: '103-42',
						topic: '尉天驄',
						time: '56分鐘',
						mp3: '尉天驄.mp3',
						introduce:
							'民國二十四年生於江蘇碭山。政大中文畢，曾任政大中文系教授、《筆匯》月刊、《文學季刊》、《文季》季刊、《中國論壇》主編。現為政大中文所、台文所名譽教授。著作包括小說集《到梵林敦去的人》；評論集《文學札記》、《民族與鄉土》、《理想的追尋》、《鄉土文學討論集》（編著）；散文集《天窗集》、《眾神》、《棗與石榴》、《歲月》等',
					},
					{
						id: '103-43',
						topic: '郝譽翔',
						time: '56分鐘',
						mp3: '郝譽翔.mp3',
					},
					{
						id: '103-44',
						topic: '洛夫、張默、瘂弦(上)',
						time: '50分鐘',
						mp3: '洛夫、張默、瘂弦(上).mp3',
					},
					{
						id: '103-45',
						topic: '洛夫、張默、瘂弦(下)',
						time: '52分鐘',
						mp3: '洛夫、張默、瘂弦(下).mp3',
					},
					{
						id: '103-46',
						topic: '陳克華',
						time: '55分鐘',
						mp3: '陳克華.mp3',
					},
					{
						id: '103-47',
						topic: '阮慶岳',
						time: '56分鐘',
						mp3: '阮慶岳.mp3',
					},
					{
						id: '103-48',
						topic: '張系國',
						time: '54分鐘',
						mp3: '張系國.mp3',
					},
					{
						id: '103-49',
						topic: '林武憲',
						time: '54分鐘',
						mp3: '林武憲.mp3',
					},
					{
						id: '103-50',
						topic: '紀大偉',
						time: '56分鐘',
						mp3: '紀大偉.mp3',
					},
					{
						id: '103-51',
						topic: '唐捐',
						time: '54分鐘',
						mp3: '唐捐.mp3',
					},
					{
						id: '103-52',
						topic: '楊念慈',
						time: '47分鐘',
						mp3: '楊念慈.mp3',
					},
				],
			},
			{
				id: '104',
				items: [
					{
						id: '104-01',
						topic: '顏艾琳',
						time: '51分鐘',
						mp3: '顏艾琳.mp3',
					},
					{
						id: '104-02',
						topic: '鍾肇政',
						time: '51分鐘',
						mp3: '鍾肇政.mp3',
						introduce:
							'鍾肇政生於桃園縣龍潭鄉九座寮，現居龍潭。曾任國民小學教師、東吳大學東語系講師，《台灣文藝》雜誌社社長兼主編，《民眾日報》副刊主任兼主編。解嚴後，曾任台灣客家公共事務協會理事長，〈台灣筆會〉會長。現任寶島客家廣播電臺董事長，總統府資政。  1951年第一篇文章〈婚後〉，刊登於《自由談》雜誌，燃起寫作興趣，從此勤奮筆耕，1961年第一部長篇小說《魯冰花》發表於《聯合報》，同年又發表《濁流三部曲》大河小說─《濁流》、《江山萬里》、《流雲》，開啟台灣大河小說創作第一人。1964年起撰寫另一部大河小說《臺灣人三部曲》─《沉淪》《滄溟行》、《插天山之歌》，歷時十年。編輯《本省籍作家作品選輯》、《台灣省青年文學叢書》、《台灣作家全集》。',
					},
					{
						id: '104-03',
						topic: '蘇偉貞',
						time: '51分鐘',
						mp3: '蘇偉貞.mp3',
						introduce:
							'主要活動是藉由廣播節目讓生活繁忙無暇以書本來閱讀的現代人，另一種接觸文學的管道，透過聲音來傳達、保存經典文學名著及保存文學家的聲音。後續並將節目帶轉至矯正機關播放，希望讓誤入歧途的受刑人也能有管道接觸文學，陶冶性情，達到潛移默化的功效或推廣至學校做為中學生課外補充的有聲教材。於102年元月起每週六晚上在教育廣播電台全國聯播，執行期程預計一年。另外還安排每月一次邀請文學家或知名人士前往矯正機關講演。 未來也會將成果集結編輯成有聲書或作品集，推廣台灣文學之美。主要活動是藉由廣播節目讓生活繁忙無暇以書本來閱讀的現代人，另一種接觸文學的管道，透過聲音來傳達、保存經典文學名著及保存文學家的聲音。後續並將節目帶轉至矯正機關播放，希望讓誤入歧途的受刑人也能有管道接觸文學，陶冶性情，達到潛移默化的功效或推廣至學校做為中學生課外補充的有聲教材。於102年元月起每週六晚上在教育廣播電台全國聯播，執行期程預計一年。另外還安排每月一次邀請文學家或知名人士前往矯正機關講演。 未來也會將成果集結編輯成有聲書或作品集，推廣台灣文學之美。主要活動是藉由廣播節目讓生活繁忙無暇以書本來閱讀的現代人，另一種接觸文學的管道，透過聲音來傳達、保存經典文學名著及保存文學家的聲音。後續並將節目帶轉至矯正機關播放，希望讓誤入歧途的受刑人也能有管道接觸文學，陶冶性情，達到潛移默化的功效或推廣至學校做為中學生課外補充的有聲教材。於102年元月起每週六晚上在教育廣播電台全國聯播，執行期程預計一年。另外還安排每月一次邀請文學家或知名人士前往矯正機關講演。 未來也會將成果集結編輯成有聲書或作品集，推廣台灣文學之美。主要活動是藉由廣播節目讓生活繁忙無暇以書本來閱讀的現代人，另一種接觸文學的管道，透過聲音來傳達、保存經典文學名著及保存文學家的聲音。後續並將節目帶轉至矯正機關播放，希望讓誤入歧途的受刑人也能有管道接觸文學，陶冶性情，達到潛移默化的功效或推廣至學校做為中學生課外補充的有聲教材。於102年元月起每週六晚上在教育廣播電台全國聯播，執行期程預計一年。另外還安排每月一次邀請文學家或知名人士前往矯正機關講演。 未來也會將成果集結編輯成有聲書或作品集，推廣台灣文學之美。主要活動是藉由廣播節目讓生活繁忙無暇以書本來閱讀的現代人，另一種接觸文學的管道，透過聲音來傳達、保存經典文學名著及保存文學家的聲音。後續並將節目帶轉至矯正機關播放，希望讓誤入歧途的受刑人也能有管道接觸文學，陶冶性情，達到潛移默化的功效或推廣至學校做為中學生課外補充的有聲教材。於102年元月起每週六晚上在教育廣播電台全國聯播，執行期程預計一年。另外還安排每月一次邀請文學家或知名人士前往矯正機關講演。 未來也會將成果集結編輯成有聲書或作品集，推廣台灣文學之美。',
					},
					{
						id: '104-04',
						topic: '李敏勇',
						time: '54分鐘',
						mp3: '李敏勇.mp3',
						introduce:
							'詩人、文化評論人、翻譯家，國立中興大學歷史學系畢業，大學時代修習歷史，曾主編《笠》詩刊、擔任「台灣文藝」社長及「台灣筆會」會長、圓神出版事業機構如何出版社社長。  出版作品有：《人生風景》、《文化風景》、《彷彿看見藍色的海與帆》、《漫步油桐花開的山林間》、《思慕與哀愁》、《自白書》、《顫慄的風景》、《台灣進行曲》、《自由啟示錄》、《革命之花》、《沈默抵抗》、《雲的語言》、《暗房》、《鎮魂歌》、《野生思考》、《戒嚴風景》、《傾斜的島》、《心的奏鳴曲》、《青春腐蝕畫》、《島嶼奏鳴曲》、《文化窗景與歷史鏡像》、《尋覓家國願景》、《文明之光，國家之影》，並編集《聽，臺灣在吟唱》、《聽，世界在吟唱》。除了詩創作外，也出版詩解說、研究，譯讀當代世界詩，並著有散文、小說、文學評論和社會評論集等約70餘冊。2007年獲得國家文藝獎。',
					},
					{
						id: '104-05',
						topic: '陳雨航',
						time: '57分鐘',
						mp3: '陳雨航.mp3',
						introduce:
							'陳雨航台師大歷史系、文化藝術研究所畢業。曾任職報紙副刊、雜誌、出版編輯多年。七○年代從事小說寫作，著作有短篇小說集《策馬入林》和《天下第一捕快》。  2012年發表首部長篇小說《小鎮生活指南》，引起熱烈迴響，並榮獲：2012年《亞洲週刊》十大小說獎、該年度中國時報開卷好書獎、2013年台北國際書展大獎等。',
					},
					{
						id: '104-06',
						topic: '吳敏顯',
						time: '55分鐘',
						mp3: '吳敏顯.mp3',
						introduce:
							'吳敏顯曾任聯合報宜蘭縣召集人、聯合副刊編輯及萬象版主編、宜蘭社區大學講師、宜蘭縣文獻委員會委員、《九彎十八拐》文學雜誌編輯等。著有散文集《我的平原》、《靈秀之鄉》、《青草地》、《與河對話》、《逃匿者的天空》、《老宜蘭的腳印》、《老宜蘭的版圖》、《宜蘭河的故事》；小說集《沒鼻牛》、《三角潭的水鬼》等書。  作品曾獲選入中國當代散文大展、中國現代文學年選、年度散文選、詩選、小說選等多項大獎。《三角潭的水鬼》並榮獲2014年好書大家讀年度最佳少年兒童讀物。',
					},
					{
						id: '104-07',
						topic: '宇文正',
						time: '57分鐘',
						mp3: '宇文正.mp3',
						introduce:
							'本名鄭瑜雯，福建林森人，東海大學中文系畢業、南加大東亞所碩士，現任《聯合報》副刊組主任。  著有短篇小說集《貓的年代》《台北下雪了》《幽室裡的愛情》《台北卡農》；散文集《負劍的少年》、《庖廚食光》《那些人住在我心中》《丁香一樣的顏色》《這是誰家的孩子》《顛倒夢想》《我將如何記憶你》；長篇小說《在月光下飛翔》；傳記《永遠的童話──琦君傳》及童書等多種。',
					},
					{
						id: '104-08',
						topic: '伊格言',
						time: '52分鐘',
						mp3: '伊格言.mp3',
						introduce:
							'曾獲聯合文學小說新人獎、自由時報林榮三文學獎、吳濁流文學獎長篇小說獎等，並入選「台灣成長小說選」、「三城記：台北卷」、「年度小說選」、「年度散文選」等選集。  2003年出版首部小說《甕中人》，已成新世代經典，並獲德國萊比錫書展、法蘭克福書展選書。著作有：短篇小說《甕中人》、《拜訪糖果阿姨》；長篇小說《噬夢人》、《零地點 GroundZero》；詩集《你是穿入我瞳孔的光》；評論散文集《幻事錄──伊格言的現代小說經典16講》。',
					},
					{
						id: '104-09',
						topic: '鍾文音',
						time: '51分鐘',
						mp3: '鍾文音.mp3',
						introduce:
							'曾任電影劇照師、記者，自2000年專職寫作至今，現為職業作家。被譽為1990年代崛起的優秀小說家，曾獲得十多項臺灣重要文學獎，包括中國文藝獎章、聯合報短篇小說獎、聯合報散文獎、中國時報短篇小說獎、長榮旅行文學獎、華航旅行文學獎、吳三連獎、林榮三文學獎等。  作品有：長篇小說：《女島紀行》、《愛別離》、《在河左岸》、《慈悲情人》、《百年物語》三部曲：《艷歌行》、《短歌行》、《傷歌行》。短篇小說：《一天兩個人》、《過去》等。散文：《寫給你的日記》、《昨日重現》、《少女老樣子》、《孤獨的房間》、《情人的城市》、《永遠的橄欖樹》、《奢華的時光》、《三城三戀》等。',
					},
					{
						id: '104-10',
						topic: '陳若曦',
						time: '47分鐘',
						mp3: '陳若曦_10410.mp3',
						introduce:
							'陳若曦，1957年入讀台大外文系，開始發表小說。1960年與白先勇、王文興等創辦「現代文學」雜誌。1962年赴美進修，1966年隨夫赴中國大陸，適逢文化大革命，候至1973年方得舉家遷居香港。1974年移居加拿大前，開始發表《尹縣長》等一系列反映文革的小說與散文，為「傷痕文學」之始。長篇《歸》獲吳三連文學獎。1979年遷居舊金山。小說創作以美華社會和兩岸三地的人情世故為題材，《紙婚》為代表作。  1995年返台定居，從教學和寫作外，積極投入「人間佛教」運動及生態和環保工作。現為婦女寫作協會常務理事及中華民國荒野保護協會會員。',
					},
					{
						id: '104-11',
						topic: '郭強生',
						time: '56分鐘',
						mp3: '郭強生.mp3',
						introduce:
							'台大外文系畢業，美國紐約大學（NYU）戲劇博士，目前為國立東華大學英美語文學系教授。曾以《非關男女》獲時報文學獎戲劇首獎，長篇小說《惑鄉之人》獲金鼎獎，《夜行之子》入圍台北國際書展大獎。近年作品並多次入選「年度散文選」與「年度小說選」，同時主編《九十九年小說選》、《作家與海》台灣海洋書寫文集等。最新長篇小說作品為《斷代》（王德威主編、當代小說家系列）。  除小說與戲劇外，其散文出版作品包括《我是我自己的新郎》、《就是捨不得》、日記文學《2003╱郭強生》，以及評論文集《如果文學很簡單，我們也不用這麼辛苦》、《文學公民》、《在文學徬徨的年代》等多部。',
					},
					{
						id: '104-12',
						topic: '凌拂',
						time: '52分鐘',
						mp3: '凌拂.mp3',
						introduce:
							'輔仁大學中文系畢業，曾任教職。創作文類以散文、兒童文學為主。作品曾獲時報文學獎、聯合報文學獎、時報開卷好書獎、聯合報讀書人最佳書獎、洪建全兒童文學獎。代表作有：《有一棵植物叫龍葵》、《帶不走的小蝸牛》、《無尾鳳蝶的生日》、《五月木棉飛》、《世人只有一隻眼》、《與荒野相遇》、《台灣的森林》、《畫字》、《天上的魚與木棉》、《學校一百歲》、《山‧城草木疏：綠活筆記》等。',
					},
					{
						id: '104-13',
						topic: '徐國能',
						time: '52分鐘',
						mp3: '徐國能.mp3',
						introduce:
							'東海大學畢業，臺灣師大文學博士，現任職於臺灣師大國文系。曾獲聯合報文學獎、時報文學獎、教育部文藝創作獎、臺灣文學獎、全國學生文學獎、全國大專學生文學獎、聯合報讀書人最佳書獎等。  著有散文集《第九味》、《煮字為藥》、《綠櫻桃》、《詩人不在，去抽菸了》、《寫在課本留白處》。',
					},
					{
						id: '104-14',
						topic: '黃寶蓮',
						time: '56分鐘',
						mp3: '黃寶蓮.mp3',
						introduce:
							'文化大學文藝組畢業。自1983起先後居住紐約、倫敦、香港，行遊四方，著有散文集《流氓治國》、《愛情帳單》、《簡單的地址》、《未竟之藍》、《仰天45度角》、《無國境世代》、《芝麻米粒說》、《56種看世界的方法》，短篇小說集《七個不快樂的女人》、《七個不快樂的男人》、《Indigo藍》，長篇小說《暴戾的夏天》。作品多次入選九歌、爾雅年度散文、小說選，台港小說選，日本現代中國文學等。',
					},
					{
						id: '104-15',
						topic: '小野',
						time: '57分鐘',
						mp3: '小野.mp3',
						introduce:
							'小野以《蛹之生》一書成為七○年代暢銷作家，曾獲得聯合報文學獎首獎及五度入圍電影金馬獎，並以《恐怖分子》、《我們都是這樣長大》、《刀瘟》等獲得英國國家編劇獎、亞太影展及金馬獎最佳劇本獎；1990年中國時報舉辦讀者票選「四十年來影響我們最深的書籍」，《蛹之生》一書獲選為民國六○年代十本書之一。  近年出版代表作品有《有些事，這些年我才懂》、《世界雖然殘酷，我們還是……》、《關於人生，我最想告訴你的事……》、《人生，不能什麼都要》等。',
					},
					{
						id: '104-16',
						topic: '劉靜娟',
						time: '53分鐘',
						mp3: '劉靜娟.mp3',
						introduce:
							'曾任《台灣新生報》副刊主編及主筆。作品以散文為主，包括《笑聲如歌》、《咱們公開來偷聽》、《歲月就像一個球》、《被一隻狗撿到》、《眼眸深處》、《布衣生活》、《輕鬆做事輕鬆玩》、《散步去》、《樂齡，今日關鍵字》等。曾獲散文類國家文藝獎。',
					},
					{
						id: '104-17',
						topic: '平路',
						time: '55分鐘',
						mp3: '平路.mp3',
						introduce:
							'本名路平，臺灣大學心理系畢業，美國愛荷華大學碩士。曾任中時晚報副刊主編、中國時報主筆、香港光華文化新聞中心主任，並曾在臺灣大學新聞研究所與臺北藝術大學藝術管理研究所任教。  重要著作包括：長篇小說《行道天涯》、《婆娑之島》、《東方之東》、《何日君再來》、《椿哥》、《墨水》等；短篇小說集《蒙妮卡日記》、《百齡箋》、《凝脂溫泉》、《五印封緘》、《玉米田之死》、《禁書啟示錄》等；散文集《浪漫不浪漫》、《讀心之書》、《我凝視》、《巫婆之七味湯》、《香港已成往事》等；長篇小說《行道天涯》、《何日君再來》以及短篇小說集已譯成英、法、日、韓等多種外文版本。',
					},
					{
						id: '104-18',
						topic: '陳俊志',
						time: '53分鐘',
						mp3: '陳俊志.mp3',
						introduce:
							'作家與紀錄片導演，作品有《不只是喜宴》《美麗少年》《玫瑰的戰爭》《幸福備忘錄》《我的愛滋朋友》與《無偶之家，往事之城》《酷兒舞台》和《沿海岸線徵友》。2006年獲邀拍攝雙年展開幕片系列之《酷兒舞台》，2007年改編詩人鯨向海的詩作，拍攝影像詩短片《沿海岸線徵友》。2007年，以台美移民家族史寫作計畫《台北爸爸，紐約媽媽》獲得台北文學獎寫作年金首獎。2008年，以高樹少年死亡事件為本，寫作《人間‧失格》，獲得時報文學獎報導文學類首獎。',
					},
					{
						id: '104-19',
						topic: '白先勇(2)',
						time: '55分鐘',
						mp3: '白先勇(2).mp3',
						introduce:
							'廣西桂林人，台大外文系畢業，後赴美到愛荷華大學作家工作室研究創作，獲碩士學位後任教於加州大學。曾創辦《現代文學》雜誌。著有短篇小說集《寂寞的十七歲》、《台北人》，長篇小說《孽子》，散文集《驀然回首》、《第六集手指》，並有劇作《遊園驚夢》等多種。白先勇吸收西洋現代文學寫作技巧，融入到中國傳統表現方式之中，描寫新舊交替時代人物的故事與生活，富歷史興衰與人世滄桑感。',
					},
					{
						id: '104-20',
						topic: '零雨',
						time: '56分鐘',
						mp3: '零雨.mp3',
						introduce:
							'零雨，台大中文系畢業，美國威斯康辛大學東亞語文研究所碩士。1991年哈佛大學訪問學者。曾任《國文天地》副總編輯、《現代詩》主編，並為《現在詩》創社發起人之一。1993年她以〈特技家族〉一詩，獲得年度詩獎。現任教於宜蘭大學。著有詩集：《城的連作》、《消失在地圖上的名字》、《特技家族》、《木冬詠歌集》、《零雨詩選》、《關於故鄉的一些計算》、《我正前往你》、《我和我的火車和你》、《田園/下午五點四十九分》等。',
					},
					{
						id: '104-21',
						topic: '畢璞',
						time: '47分鐘',
						mp3: '畢璞.mp3',
						introduce:
							'畢璞，本名周素珊，曾任《大華晚報》、《徵信新聞報》（中國時報前身）家庭版主編、《公論報》副刊主編、《徵信新聞》家庭版主編、《婦友月刊》總編輯等職，現已退休專心從事創作。  作品橫跨散文、小說、兒童故事、雜文、評論、傳記等，也翻譯過英美的文學作品。已出版的著作有《故國夢重歸》、《風雨故人來》、《寂寞黃昏後》、《心燈集》、《秋夜宴》、《綠萍姊妹》、《無言歌》、《清音》、《春花與春樹》、《明日又天涯》、《畢璞自選集》、《老樹春深更著花》、《有情世界》等。作品亦曾選入國中國文課本中。',
					},
					{
						id: '104-22',
						topic: '方梓',
						time: '53分鐘',
						mp3: '方梓.mp3',
						introduce:
							'方梓，本名林麗貞，文化大學大眾傳播系畢業，國立東華大學創作與英美文學研究所碩士。  曾任消基會《消費者報導》雜誌總編輯、全國文化總會學術研究組企畫、《自由時報．副刊》副主編、總統府專門委員，及大學兼任講師。著有《人生金言》、《他們為什麼成功》、《傑出女性的宗教觀》、《第四個房間》、《采采卷耳》、《來去花蓮港》、《野有蔓草：野菜書寫》等。',
					},
					{
						id: '104-23',
						topic: '舒國治',
						time: '57分鐘',
						mp3: '舒國治.mp3',
						introduce:
							'舒國治，散文家。七十年代末以短篇小說〈村人遇難記〉獲時報文學獎而深受文壇矚目。1982年寫完《讀金庸偶得》，有頗長時日擱筆。1983至1990，七年浪跡美國。返台後所寫，多及旅行，所寫之一九九七第一屆華航旅行文學獎首獎作品〈香港獨遊〉與1998第一屆長榮旅行文學獎首獎作品〈遙遠的公路〉，可見一斑。被譽為台灣旅行寫作的重要奠基者。其所著《水城臺北》又被譽為寫「台北舊昔」最出色者。著有《門外漢的京都》、《流浪集》、《理想的下午》、《台北小吃札記》、《宜蘭一瞥》、《台北游藝》等書。',
					},
					{
						id: '104-24',
						topic: '凌性傑',
						time: '57分鐘',
						mp3: '凌性傑.mp3',
						introduce:
							'凌性傑，師大國文系、中正大學中文所碩士班畢業，東華大學中文所博士班肄業。曾獲台灣文學獎、林榮三文學獎、中國時報文學獎、中央日報文學獎、梁實秋文學獎、教育部文藝獎。現任教於建國中學，著有《自己的看法》、《更好的生活》、《有故事的人》、《2008／凌性傑》、《找一個解釋》、《有信仰的人》、《愛抵達》、《彷彿若有光》、《慢行高雄》等書；編著有《靈魂的領地：國民散文讀本》（與楊佳嫻合編）。',
					},
					{
						id: '104-25',
						topic: '馮翊綱',
						time: '51分鐘',
						mp3: '馮翊綱.mp3',
						introduce:
							'馮翊綱，國立藝術學院戲劇藝術碩士，「相聲瓦舍」創辦人暨藝術總監，當代相聲劇場的代表性人物。著作包括研究文集、文藝作品集、劇本集、有聲書、圖文書等多部，以及影音光碟數十種。曾獲國軍文藝金像獎、文建會舞台劇本創作獎、中國文藝獎章、十大傑出青年薪傳獎、全球中華文化藝術薪傳獎。創意事業之外，兼任多項大學課程，現為台北藝術大學戲劇系、政治大學廣電系、台灣師範大學音樂系副教授。',
					},
					{
						id: '104-26',
						topic: '黃麗群',
						time: '52分鐘',
						mp3: '黃麗群.mp3',
						introduce:
							'黃麗群，政大哲學系畢。曾獲時報文學獎短篇小說評審獎；聯合報文學獎短篇小說評審獎、短篇小說首獎；林榮三文學獎短篇小說二獎（首獎從缺）。作品曾入選《九十四年小說選》（九歌）、《九十九年小說選》（九歌）、《一○一年散文選》（九歌）、《二○一三飲食文學》（二魚）。著有小說集《海邊的房間》（2012）、散文集《背後歌》。',
					},
					{
						id: '104-27',
						topic: '趙天儀',
						time: '49分鐘',
						mp3: '趙天儀.mp3',
						introduce:
							'趙天儀，臺灣大學哲學系研究所畢業。曾任臺大哲學系教授兼系主任、國立編譯館人文組編纂、靜宜大學文學院院長、臺灣省兒童文學協會理事長。  兒童文學創作主要為童詩及論述。著有：《小麻雀的遊戲》、《變色鳥》等。編著：《如何寫好童詩》、《兒童詩初探》、《臺灣兒童文學的出發》、《少年小說論文集》等。曾榮獲臺灣省臺中文藝協會自強文藝獎章新詩獎、巫永福評論獎、行政院文建會文耕獎、大墩文學獎、臺灣文學家牛津獎等。',
					},
					{
						id: '104-28',
						topic: '苦苓',
						time: '56分鐘',
						mp3: '苦苓.mp3',
						introduce:
							'苦苓，本名王裕仁，臺大中文系畢業。曾任中學教師、雜誌編輯、廣播電視主持人，獲《中國時報》散文獎、《聯合報》小說獎，《中外文學》現代詩獎及吳濁流文學獎，著作五十餘種，暢銷逾百萬冊。現為雪霸國家公園解說志工，沉潛八年，驚豔於天地萬物超乎想像的各種生命形式，遂提筆書寫自然，其旅遊及生態作品散見部落格「苦苓好好玩」。  2011年開始，陸續出版《苦苓與瓦幸的魔法森林》、《苦苓的森林祕語》，成功開創新型態書寫，以生動詼諧的方式開啟認識自然的全新視角。2013年寫下《我在離離離島的日子》，以散文形式深刻反思人類與自然的親密關係。2015年最新力作《請勿對號入座》，則用諷刺中帶有戲謔的筆鋒，描寫各種奇人異事，再掀膾炙人口的「極短篇」風潮。',
					},
					{
						id: '104-29',
						topic: '桂文亞',
						time: '56分鐘',
						mp3: '桂文亞.mp3',
						introduce:
							'桂文亞，台灣兒童文學家，曾任民生報兒童版主任，海峽兩岸兒童文學交流的重要推手。  創作超過30種，編輯的少年和兒童讀物更接近400種。著名兒童文學作品包括：《思想貓》、《班長下臺》、《感覺的盒子》、《二郎橋那個野丫頭》、《美麗眼睛看世界》、《長著翅膀遊英國》、《哈瑪！哈瑪！伊斯坦堡》等。著有《煙塵小札》、《墨香》、《春暉與春天》、《媽媽手記》等。',
					},
					{
						id: '104-30',
						topic: '王拓',
						time: '56分鐘',
						mp3: '王拓.mp3',
						introduce:
							'王拓，國立政治大學文學碩士，美國愛荷華大學國際寫作計劃作家。曾任中學教師、國民大會代表，現任立法委員。著有：短篇小說集《金水嬸》、《望君早歸》，長篇小說集：《牛肚港的故事》、《台北．台北》，評論集：《街巷鼓聲》、《張愛玲與宋江》，兒童故事集：《咕咕精與小老頭》等。',
					},
					{
						id: '104-31',
						topic: '羅青',
						time: '53分鐘',
						mp3: '羅青.mp3',
						introduce:
							'羅青本名羅青哲，因其父親與書畫家交好，羅青哲於13歲起，隨溥心畲習北宗山水，16歲時隨任博悟習南宗潑墨。曾任職於國立臺灣師範大學英語系所、美術系所及翻研所教授，並兼任中國語言文化中心主任。1972年出版了第一本詩集《吃西瓜的方法》。余光中在〈新現代詩的起點－－羅青的《吃西瓜的方法》讀後〉一文中，稱讚羅青的詩作為「新現代詩」的起點，羅青開始在文壇展露頭角。1974年獲頒第一屆中國現代詩獎，1975年與朋友創立草根詩社，出版《草根》詩刊。1996年獲《鹿特丹國際詩人》推薦獎。  羅青哲的水墨繪畫也獲得藝壇重視，1973年，於西雅圖第一國家銀行展覽廳，首次展出個展。此後在國內外各藝術中心，多次舉辦展覽。1987年獲《雄獅美術雙年展》大獎，2004第四屆《米蘭國際藝術節藝》藝術家獎。2004年，獲得第四屆《米蘭國際藝術節》藝術家獎。',
					},
					{
						id: '104-32',
						topic: '黃海',
						time: '53分鐘',
						mp3: '黃海.mp3',
						introduce:
							'黃海本名黃炳煌，曾任僑訊半月刊主編、兼任兒童月刊主編、科學兒童周刊主編。聯合報編輯退休；退休後兼任靜宜大學、世新大學「台灣文學」「科幻文學」講師，東吳大學「科幻與現代文明」講座；倪匡科幻獎、U19科幻小小說獎、教育部文藝創作獎等決審委員。從事文學創作數十年，作品涵蓋成人文學與兒童文學的領域、科幻文學與傳統文學的文類。臺灣唯一以科幻作品獲得國家文藝獎（舊制）、中山文藝獎的作家。  作品有：《一０一０一年》、《新世紀之旅》、《銀河迷航記》、《天外異鄉人》、《偷腦計畫》、《天堂鳥》、《最後的樂園》、《第四類接觸》、《星星的項練》、《鼠城記》、《永康街共和國》、《黃海童話》、《地球逃亡》、《奈米魔幻兵團》等。',
					},
					{
						id: '104-33',
						topic: '席慕蓉',
						time: '54分鐘',
						mp3: '席慕蓉.mp3',
						introduce:
							'席慕蓉台灣現代中文散文家、女詩人、知名畫家。 曾於東海大學美術系任教。1981年，年出版第一本詩集《七里香》，出版後引起轟動，熱銷致短時間內重印六次。數年後出版第二本詩集《無怨的青春》。1979年四月．開始研究雷射繪畫，舉辦數次個展，是一位專攻油畫並兼習版畫的藝術家。 畫作曾獲比利時皇家金牌獎。  著作有：  詩集：《七里香》、《無怨的青春》、《時光九篇》、《邊緣光影》、《迷途詩冊》、《我折疊著我的愛》、《以詩之名》 ；散文集：《有一首歌》、《江山有待》、《金色的馬鞍》、《席慕蓉精選集》、《人間煙火》、《寫生者》、《評論十家》、《我家在高原上》、《寧靜的巨大》、《寫給海日汗的21封信》、《成長的痕跡》、《給我一個島》；美術論著：《心靈的探索》、《雷色藝術異論》、《彩墨．千山．馬白水》。',
					},
					{
						id: '104-34',
						topic: '林宜澐',
						time: '52分鐘',
						mp3: '林宜澐.mp3',
						introduce:
							'林宜澐，曾任《中國時報》編輯、慈濟護專講師、大漢技術學院副教授及通識教育中心主任、國立東華大學華文文學系副教授、《東海岸評論》總編、東村出版總編。  著作  短篇小說集：《人人愛讀喜劇》、《藍色玫瑰》、《惡魚》、《夏日鋼琴》、《耳朵游泳》、《晾著》、《河岸花園了》；長篇小說：《海嘯》；散文：《東海岸減肥報告書》；論述：《哲學與人生》。',
					},
					{
						id: '104-35',
						topic: '高大鵬',
						time: '54分鐘',
						mp3: '高大鵬.mp3',
						introduce:
							'高大鵬，曾任《聯合文學》總編輯，現任教於大專院校。著作有散文集《追尋》，詩集《獨樂園》，評論集《文海偶拾》，論文集《陶詩新論》、《少年胡適與中國文藝復興運動》等，雜文集《吹不散的人影》等。曾獲：金鼎獎、時報文學散文推荐獎、中山文藝獎、國家文藝獎等多項大獎。',
					},
					{
						id: '104-36',
						topic: '花柏容',
						time: '58分鐘',
						mp3: '花柏容.mp3',
						introduce:
							'花柏容，2011文學重力圈一致注目超級新星 聯合文學、林榮三、聯合報三大文學獎得主。著有《愛貪小便宜的安娜》、《被劫持的影子》、《龜島少年》等。',
					},
					{
						id: '104-37',
						topic: '簡政珍',
						time: '57分鐘',
						mp3: '簡政珍.mp3',
						introduce:
							'簡政珍，曾任創世紀詩刊主編、中興大學外文系教授、系主任，亞洲大學人文社會學院院長。現任亞洲大學外文系講座教授。研究領域為英美文學、比較文學、文學理論、現代詩與詩學、詩創作。  著有詩集《季節過後》、《歷史的騷味》、《浮生紀事》、《失樂園》、《當鬧鐘與夢約會》、《放逐與口水的年代》等十種；詩文論集：《空隙中的讀者》(英文)、《語言與文學空間》、《詩心與詩學》、《放逐詩學》、《電影閱讀美學》、《台灣現代詩美學》、《當代詩與後現代的雙重視野》、《解構閱讀法》、《讀者反應閱讀法》等十七種。主編《當代文學理論》、《新世代詩人精選集》，與大陸吳思敬、澳門傅天虹共同主編《兩岸四地中生代詩選》。  曾獲美國的大學博士論文獎，中國文藝學會新詩創作獎，創世紀詩刊三十五周年詩獎，行政院新聞局金鼎獎等。2007年3月北京師範大學珠海分校曾為其舉辦「兩岸中生代詩學高層論壇暨簡政珍作品研討會」。',
					},
					{
						id: '104-38',
						topic: '高翊峰',
						time: '57分鐘',
						mp3: '高翊峰.mp3',
						introduce:
							'高翊峰，小說家，《FHM》國際中文版雜誌總編輯。  文化大學法律系畢業。曾從事雜誌編輯、廣告文案，以及編劇工作。雜誌工作曾擔任《Cosmopolitan》副總編輯、《GQ》雜誌副總編輯，以及《MAXIM》中國版雜誌編輯總監。文字作品曾獲得林榮三文學獎、聯合報文學獎、時報文學獎、中央日報文學獎等四大報文學獎。改編同名小說〈肉身蛾〉獲得金鐘獎迷你劇集「最佳編劇獎」。出版品有《家，這個牢籠》、《肉身蛾》、《傷疤引子》、《奔馳在美麗的光裡》、《一公克的憂傷》等短篇集。長篇小說《幻艙》，短篇小說集《烏鴉燒》。',
					},
					{
						id: '104-39',
						topic: '杜潘芳格',
						time: '55分鐘',
						mp3: '杜潘芳格.mp3',
						introduce:
							'杜潘芳格，台灣客籍女詩人，1965年加入強調本土意識的笠詩社，八零年代開始積極從事客語詩的創作。九零年代曾任《台灣文藝》雜誌社社長，女鯨詩社社長；1992年年以北京語、英語與日語寫成的詩集《遠千湖》，獲第一屆陳秀喜詩獎。2007年，杜潘方格獲行政院客委會頒發「傑出貢獻獎」及「台灣新文學貢獻獎」。2008年獲真理大學台灣文學家牛津獎。  主要作品有《中元節》、《平安戲》、《紙人》、《菜園》等。',
					},
					{
						id: '104-40',
						topic: '古蒙仁',
						time: '56分鐘',
						mp3: '古蒙仁.mp3',
						introduce:
							'古蒙仁，本名林日揚，曾任中國時報撰述委員、中央日報副總編輯、國家文化藝術基金會副執行長、雲林縣文化局局長、文建會主委辦公室主任、國家文化總會顧問；並曾任教中興大學、中央大學中文系。  古蒙仁多次獲時報文學獎、中興文藝獎、吳三連文藝獎。作品以報導文學、小說、散文為主。著有《黑色的部落》、《失去的水平線》、《雨季中的鳳凰花》、《吃冰的另一種滋味》、《凝視北歐》、《溫室中的島嶼》、《台灣山海經》、《虎尾溪的浮光》、《大道之行》等三十餘種書籍。',
					},
					{
						id: '104-41',
						topic: '羊子喬',
						time: '56分鐘',
						mp3: '羊子喬.mp3',
						introduce:
							'羊子喬，本名楊順明，現職國立臺灣文學館助理研究員，曾任遠景出版公司主編、自立報系資深編輯、南投縣政府簡任秘書、前衛出版社總編輯、遠流專業版《台灣大百科》文學卷專案主編、靜宜大學講師。1995年榮獲第三屆南瀛文學貢獻獎。  著有：詩集《月浴》、《收成》、《該是春天為我們開門的時候》、《羊子喬卅年詩選》、《羊子喬集》；散文集《太陽手記》、《輪迴》、《走過人生街頭》、《微笑人生》；合集《羊子喬詩文集》；評論集《蓬萊文章台灣詩》、《神秘的觸鬚》、《島上詩鼓手─陳千武文學評傳》、《鹽田裡的詩魂》及碩士論文《黑潮輓歌─楊華及其作品研究》。編有：《光復前台灣文學全集》十二冊、《鹽分地帶文選》、《郭水潭集》、《藍紅綠作品集》、《楊華作品集》等多種。',
					},
					{
						id: '104-42',
						topic: '楊青矗2',
						time: '56分鐘',
						mp3: '楊青矗2.mp3',
						introduce:
							'楊青矗，台灣鄉土文學作家，中華民國前國策顧問，本名楊和雄，曾任美麗島雜誌高雄分社主任，台灣筆會會長及敦理出版社發行人、社長。他的工人小說在臺灣鄉土文學論戰成為討論對象。1979年因美麗島事件入獄，1983年出獄。代表作為《在室男》、《工廠女兒圈》、《心癌》、《連雲夢》、《工廠人》、《楊青矗與國際作家對話》、《在室女》、《給台灣的情書》、《生命的旋律》、《筆聲的迴響》、《女企業家》等，此外還編有《台華雙語辭典》、《台語注音讀本》、《台語語彙辭典》、《台灣俗語辭典》、《台詩三百首》等書，他的文學具有國際知名度。',
					},
					{
						id: '104-43',
						topic: '李進文',
						time: '56分鐘',
						mp3: '李進文.mp3',
						introduce:
							'李進文，現任聯合文學出版社總編輯、創世紀詩社主編；曾任記者、明日工作室副總經理。  著有詩集《一枚西班牙錢幣的自助旅行》、《不可能；可能》、《長得像夏卡爾的光》、《除了野薑花，沒人在家》、《靜到突然》、《雨天脫隊的點點滴滴》；散文集《蘋果香的眼睛》、《如果MSN是詩，E-mail是散文》；圖文詩集《油菜花寫信》、動畫童詩繪本《騎鵝歷險記》及《字然課》、美術詩集《詩與藝的邂逅》；編有《Dear Epoch──創世紀詩選1994～2004》等。  曾獲時報文學獎、聯合報文學獎、中央日報文學獎、臺北文學獎、臺灣文學獎、吳濁流文學獎、林榮三文學獎、2006年度詩人獎、文化部數位金鼎獎、入選九歌版《台灣文學30年菁英選》之新詩30家等。',
					},
					{
						id: '104-44',
						topic: '李喬',
						time: '53分鐘',
						mp3: '李喬.mp3',
						introduce:
							'李喬，本名李能棋，台灣戰後第二代作家。曾獲第三屆「台灣文學獎」（1968）、第四屆「吳三連文藝獎」（1981）、第十四屆「巫永福評論獎」（1993）、台美基金會「社科人才成就獎」（1995）、第十屆「國家文藝獎」（2006）、行政院客委會「客家文化終身貢獻獎」（2007）、獲頒靜宜大學「第一屆蓋夏論壇講座」（2010）、真理大學「台灣文學家牛津獎」（2010）。  出版「寒夜三部曲」（《寒夜》、《荒村》、《孤燈》）、「幽情三部曲」（《咒之環》、《V與身體》、《散靈堂傳奇》）、《情世界：回到未來》、《李喬短篇小說全集》11冊、《重逢夢裡的人：李喬短篇小說後傳》等。另有文學及文化論述、劇本、敘事詩等作品，其創作成果總計九百餘萬字。  代表作「寒夜三部曲」等有英日文譯本，並由公共電視於2003年拍成四十輯連續劇，另有福台語歌仔戲、客台語舞台劇演出。',
					},
					{
						id: '104-45',
						topic: '宋澤萊',
						time: '56分鐘',
						mp3: '宋澤萊.mp3',
						introduce:
							'宋澤萊，本名廖偉竣，為戰後以小說成名，同時也創作新詩、散文，還致力於評論與理論研究的傑出作家，更是台灣本土意識與新文化運動的重要旗手。2013年榮獲第十七屆國家文藝獎，吳濁流小說及新詩首獎、時報文學獎推薦獎、聯合報文學獎佳作獎、吳三連文學獎、東元科技人文獎。',
					},
					{
						id: '104-46',
						topic: '林亨泰',
						time: '53分鐘',
						mp3: '林亨泰.mp3',
					},
					{
						id: '104-47',
						topic: '房慧真',
						time: '53分鐘',
						mp3: '房慧真.mp3',
					},
					{
						id: '104-48',
						topic: '心岱',
						time: '57分鐘',
						mp3: '心岱.mp3',
					},
					{
						id: '104-49',
						topic: '周志文',
						time: '57分鐘',
						mp3: '周志文.mp3',
					},
					{
						id: '104-50',
						topic: '林德俊',
						time: '57分鐘',
						mp3: '林德俊.mp3',
					},
					{
						id: '104-51',
						topic: '張維中',
						time: '57分鐘',
						mp3: '張維中.mp3',
					},
					{
						id: '104-52',
						topic: '馬森',
						time: '56分鐘',
						mp3: '馬森.mp3',
					},
				],
			},
			{
				id: '105',
				items: [
					{
						id: '105-01',
						topic: '張錯',
						time: '56分鐘',
						mp3: '張錯.mp3',
					},
					{
						id: '105-02',
						topic: '李長青',
						time: '56分鐘',
						mp3: '李長青.mp3',
					},
					{
						id: '105-03',
						topic: '曾貴海',
						time: '56分鐘',
						mp3: '曾貴海.mp3',
					},
					{
						id: '105-04',
						topic: '林文月',
						time: '59分鐘',
						mp3: '林文月.mp3',
					},
					{
						id: '105-05',
						topic: '許榮哲',
						time: '57分鐘',
						mp3: '許榮哲.mp3',
					},
					{
						id: '105-06',
						topic: '楊佳嫻',
						time: '58分鐘',
						mp3: '楊佳嫻.mp3',
					},
					{
						id: '105-07',
						topic: '朱衣',
						time: '58分鐘',
						mp3: '朱衣.mp3',
					},
					{
						id: '105-08',
						topic: '張耀仁',
						time: '57分鐘',
						mp3: '張耀仁.mp3',
					},
					{
						id: '105-09',
						topic: '李志薔',
						time: '57分鐘',
						mp3: '李志薔.mp3',
					},
					{
						id: '105-10',
						topic: '洪素麗',
						time: '56分鐘',
						mp3: '洪素麗.mp3',
					},
					{
						id: '105-11',
						topic: '曹永洋',
						time: '56分鐘',
						mp3: '曹永洋.mp3',
					},
					{
						id: '105-12',
						topic: '張亦絢',
						time: '57分鐘',
						mp3: '張亦絢.mp3',
					},
					{
						id: '105-13',
						topic: '張國立',
						time: '58分鐘',
						mp3: '張國立.mp3',
					},
					{
						id: '105-14',
						topic: '秀陶',
						time: '56分鐘',
						mp3: '秀陶.mp3',
					},
					{
						id: '105-15',
						topic: '蓉子',
						time: '59分鐘',
						mp3: '蓉子.mp3',
					},
					{
						id: '105-16',
						topic: '章緣',
						time: '57分鐘',
						mp3: '章緣.mp3',
					},
					{
						id: '105-17',
						topic: '張瀛太',
						time: '58分鐘',
						mp3: '張瀛太.mp3',
					},
					{
						id: '105-18',
						topic: '鍾喬',
						time: '58分鐘',
						mp3: '鍾喬.mp3',
					},
					{
						id: '105-19',
						topic: '紀蔚然',
						time: '56分鐘',
						mp3: '紀蔚然.mp3',
					},
					{
						id: '105-20',
						topic: '陳塡',
						time: '57分鐘',
						mp3: '陳塡.mp3',
					},
					{
						id: '105-21',
						topic: '楊照',
						time: '57分鐘',
						mp3: '楊照.mp3',
					},
					{
						id: '105-22',
						topic: '陳玉慧',
						time: '57分鐘',
						mp3: '陳玉慧.mp3',
					},
					{
						id: '105-23',
						topic: '既晴',
						time: '58分鐘',
						mp3: '既晴.mp3',
					},
					{
						id: '105-24',
						topic: '履彊',
						time: '68分鐘',
						mp3: '履彊.mp3',
					},
					// { 客戶找不到檔案
					// 	id: '105-25',
					// 	topic: '康芸薇',
					// 	time: '56分鐘',
					// 	mp3: '康芸薇.mp3',
					// },
					{
						id: '105-26',
						topic: '孫大川',
						time: '55分鐘',
						mp3: '孫大川.mp3',
					},
					{
						id: '105-27',
						topic: '李儀婷',
						time: '56分鐘',
						mp3: '李儀婷.mp3',
					},
					{
						id: '105-28',
						topic: '王浩一',
						time: '55分鐘',
						mp3: '王浩一.mp3',
					},
					{
						id: '105-29',
						topic: '王瓊玲',
						time: '56分鐘',
						mp3: '王瓊玲.mp3',
					},
					{
						id: '105-30',
						topic: '葉維廉',
						time: '57分鐘',
						mp3: '葉維廉.mp3',
					},
					{
						id: '105-31',
						topic: '綠蒂',
						time: '57分鐘',
						mp3: '綠蒂.mp3',
					},
					{
						id: '105-32',
						topic: '成英姝',
						time: '56分鐘',
						mp3: '成英姝.mp3',
					},
					{
						id: '105-33',
						topic: '陳銘磻',
						time: '56分鐘',
						mp3: '陳銘磻.mp3',
					},
					{
						id: '105-34',
						topic: '李時雍',
						time: '55分鐘',
						mp3: '李時雍.mp3',
					},
					{
						id: '105-35',
						topic: '林建隆',
						time: '56分鐘',
						mp3: '林建隆.mp3',
					},
					{
						id: '105-36',
						topic: '李魁賢',
						time: '57分鐘',
						mp3: '李魁賢.mp3',
					},
					{
						id: '105-37',
						topic: '許水富',
						time: '57分鐘',
						mp3: '許水富.mp3',
					},
					{
						id: '105-38',
						topic: '羅毓嘉',
						time: '56分鐘',
						mp3: '羅毓嘉.mp3',
					},
					{
						id: '105-39',
						topic: '李瑞騰',
						time: '58分鐘',
						mp3: '李瑞騰.mp3',
					},
				],
			},
		],
		year: ['102', '103', '104', '105']
	},
};

export const reducer = {
	read: handleActions<State, any>( // eslint-disable-line @typescript-eslint/no-explicit-any
		{
			GET_MULTIMEDIA_READ_LIST: () => defaultState,
		},
		defaultState,
	), // eslint-disable-line @typescript-eslint/no-explicit-any
};

/* +----------------------------------------------------------------------
++ selectMultiMediaReadList ++
++----------------------------------------------------------------------*/

const selectMultiMediaReadList = (state: GlobalState) => state.read.readList;
// for local demo
export const useMultiMediaReadList = () => useRedux(selectMultiMediaReadList, {});
